import { WENT_WRONG_MSG } from "../constants/Constants";
import { AZURE_URL } from "../constants/env-constants";

export const getAllPatients = async () => {
  try {
    const response = await AZURE_URL.get("/patient/get/all");
    return response;
  } catch (error: any) {
    return error.response.data;
  }
};

export const getPatientByPublicId = async (id: string) => {
  try {
    const response = await AZURE_URL.get(`/patient/get?publicId=${id}`);
    return response;
  } catch (error: any) {
    console.log(error.response.data);
    return error.response;
  }
};

export const createPatient = async (userData: CreatePatientInterface) => {
  try {
    const response = await AZURE_URL.post("/patient/create", userData);
    if (response.status === 200 || response.status === 201) {
      return [response.data, null];
    } else {
      return [null, response.data];
    }
  } catch (error: any) {
    if (error.response.status === 400) {
      return [null, error.response.data];
    } else {
      return [null, error || WENT_WRONG_MSG];
    }
  }
};

export const updatePatient = async (patientData: any) => {
  try {
    const response = await AZURE_URL.put("/patient/update", patientData);
    if (response?.status >= 200 && response.status < 300) {
      return [response.data, null];
    } else if (response?.status >= 400 && response.status < 600) {
      return [null, response.data];
    } else {
      return [null, response.data];
    }
  } catch (error: any) {
    if (error.response.status === 400) {
      return [null, error.response.data];
    } else {
      return [null, error || WENT_WRONG_MSG];
    }
  }
};

export const searchPatient = async (namePart: string) => {
  try {
    const response = await AZURE_URL.get(
      `/patient/search?searchTerm=${namePart}`
    );
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export const getAllAllergies = async () => {
  try {
    const response = await AZURE_URL.get(`/patient/allergies/get/all`);
    if (response.status === 200) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return error.response;
  }
};

export const removePartner = async (data: RemovePartner) => {
  try {
    const response = await AZURE_URL.put(`/patient/update`, data);
    if (response.status === 200) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return error.response;
  }
};
